import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=068453b0&scoped=true&"
import script from "./uploadFiles.vue?vue&type=script&lang=js&"
export * from "./uploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=068453b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068453b0",
  null
  
)

export default component.exports